import axiosInstance from "../instance/axiosInstance";

class AuthApi {
  static async login(credentials) {
    try {
      const response = await axiosInstance.post("/login", credentials);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async logout() {
    try {
      const response = await axiosInstance.get("/logout");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async reqPasswordReset(credentials) {
    try {
      const response = await axiosInstance.post(
        "/password/reset-request",
        credentials
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async resetPassword(credentials) {
    try {
      const response = await axiosInstance.post("/password/reset", credentials);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async signup(payload) {
    try {
      const response = await axiosInstance.post("/register", payload);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async checkEmail(email) {
    try {
      const response = await axiosInstance.post("/check-email", { email });
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getAuthenticatedUser() {
    try {
      const response = await axiosInstance.get("/get-authenticated-user");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async checkResetToken(formData) {
    try {
      const response = await axiosInstance.post(
        "/password/check-reset-token",
        formData
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
}

export default AuthApi;
